

export default () => async (params) => {
    const text = params.text || params
    alert(typeof (text) === 'object' ? JSON.stringify(text, null, 2) : text);
}